import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Filters } from "./Filters"
import {API_URL, sitename} from "constants/constants"
import Table from "./Table"
import axios from "axios"
import moment from "moment";

const TaxReport = props => {
  const [texReport, setTexReport] = useState([])
  const [selectedMonth, setSelectedMonth] = useState(moment().format("YYYY-MM"))
  const [loadingMessage, setLoadingMessage] = useState("1");
  useEffect(() => {
    call()
  }, [])
  const call = () => {
    setLoadingMessage("1");
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/tax-reports?month=${selectedMonth}`,
    })
        .then(function (response) {
          setTexReport(response?.data?.data)
          setLoadingMessage("0");
        })
        .catch(function (response) {
        })
  }
  useEffect(() => {
    call()
  }, [selectedMonth])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Tax Report" />
        </Container>
        <Filters setSelectedMonth={setSelectedMonth} selectedMonth={selectedMonth}/>
        <Table data={texReport} loadingMessage={loadingMessage}
                       setLoadingMessage={setLoadingMessage}/>
      </div>
    </React.Fragment>
  )
}

export default withRouter(TaxReport)
